<template>
  <CContainer fluid>
    <h3>Directorio de Clientes, Proveedores y Prospectos</h3>
    <CCard class="mt-4">
      <CCardBody class="p-4">
        <CRow>
          <CCol col="sm-6">
            <CInput
              label="Buscar:" 
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="sm-6">
            <CSelect 
              class="col-sm-6 d-inline-block"
              label="Tipo directorio:" 
              addLabelClasses="text-muted font-weight-bold"
              :options="directoryTypes"
              @update:value="value => getData(1, '', selectedDirectoryType=value)"
            />
            <CButton v-if="selectedDirectoryType === 'prospecto'"
              class="ml-2"
              color="success"
              :to="endpointAddContact">
              <i class="bi bi-plus-circle mr-2"></i>
              <span class="align-middle">Agregar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable                  
          hover
          responsive
          :items="directories"
          :fields="fields"
          :items-per-page="itemsPerPage"
          @row-clicked="(item, index, _columnName, e) => {
            e.preventDefault();
            e.stopPropagation();
            
            goTo(item, 'detalle')
          }" >
          
          <template #colEmpresa="{item}">
            <td>
              <div>
                <h4>{{ item.empresa }}</h4>
              </div>
              <div>
                <span><i class="bi bi-postcard mr-1"></i>{{item.identificacion}}</span>
              </div>
              <div>
                <i class="bi bi-person-badge" mr-1></i>
                {{ item.empleado }}
              </div>
            </td>
          </template>

          <template #colUbicacion="{item}">
            <td class="d-flex flex-column" style="border-top: none;">
              <span><i v-if="item.direccion" class="bi bi-geo-fill" style="height: 1rem; width: 1rem; display: inline-block;"></i> {{ ifNullOrUndefinedReturnEmpty(item.direccion) }}</span>
              <span>{{ ifNullOrUndefinedReturnEmpty(item.direccion_Aux) }}</span>
              <span><CIcon name="cil-map"/> {{ ifNullOrUndefinedReturnEmpty(item.ciudad) }} - {{ ifNullOrUndefinedReturnEmpty(item.departamento) }}</span>
            </td>
          </template>
          
          <template #colInformacion="{item}">
            <td>
              <div>
                <CBadge :color="getColor(item.estado_Cliente)">
                  {{ getStatus(item.estado_Cliente) }}
                </CBadge>
              </div>
            </td>
          </template>

          <template #colAccion="{item}">
            <td>
              <a
                href="#"
                @click="toggleDocument($event, item)"
                style="text-decoration: none;"
                class="mb-2 p-2">
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'" />
              </a>
            </td>
          </template>

          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <!-- flex-row-reverse -->
              <div class="d-flex justify-content-end" v-if="selectedDirectoryType === 'prospecto'">
                <a href="#" 
                  class="m-2" 
                  @click="goTo(item, 'editar')">
                  <CIcon name="cil-pencil" size="lg" class="text-warning"></CIcon>
                </a>
                <a href="#" 
                  class="m-2" 
                  @click="(event) => tryDelete(event, item.id_Directorio)">
                  <CIcon name="cil-trash" size="lg" class="text-danger"></CIcon>
                </a>
              </div>
              <CRow class="mx-1">
                <CCol col="12" sm="4">
                  <div>
                    <i class="bi bi-info-circle mr-1"></i>
                    {{ ifNullOrUndefinedReturnEmpty(directoryType[item.tipo_Directorio]) }}
                  </div>

                  <div>
                    <i class="bi bi-clock-history mr-1"></i>
                    {{ item.ultima_Actualizacion ? moment(item.ultima_Actualizacion).format('DD/MM/YYYY HH:mm:ss') : '' }}
                  </div>
                </CCol>
                <CCol col="12" sm="4">
                  <div v-if="item.tipo_Directorio === 'CL' || (item.tipo_Directorio === 'CP')">
                    <i class="bi bi-cash-coin" style="height: 1rem; width: 1rem; display: inline-block;"/>
                    <span> {{ formatter.format(item.valor_VentasAnio ? item.valor_VentasAnio : 0, 0) }}</span>
                  </div>
                  <div v-if="item.tipo_Directorio === 'CL' || (item.tipo_Directorio === 'CP')">
                    <i class="bi bi-bag-check" style="height: 1rem; width: 1rem; display: inline-block;"/>
                    <span> {{ item.cantidad_VentasAnio }}</span>
                  </div>
                  <div>
                    <i class="bi bi-cart-check mr-2"></i>
                    <span>{{item.ultima_Compra ? moment(item.ultima_Compra).format("DD/MM/YYYY") : ""}}</span>
                  </div>
                </CCol>
                <CCol col="12" sm="4">
                  <div>
                    <i class="bi bi-credit-card mr-2"></i>
                    <span class="font-weight-bold">${{ formatter.format(item.cupo_Credito, 0) }}</span>
                  </div>
                  <div>
                    <i class="bi bi-calendar3 mr-1"></i>
                    <span>{{ item.plazo_PagoCliente }} D&iacute;as</span>
                  </div>
                  <div>
                    <i class="bi bi-briefcase mr-2"></i>
                    <span class="font-weight-bold">${{formatter.format(item.saldo_Deuda ? item.saldo_Deuda : 0, 0)}}</span>
                  </div>
                  <div>
                    <CIcon name="cil-truck" class="mr-2" />
                    <span class="text-danger font-weight-bold">${{formatter.format(item.valor_Remisiones ? item.valor_Remisiones : 0, 0)}}</span>
                  </div>
                </CCol>
              </CRow>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination
          class="d-flex justify-content-center"
          size="sm"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)">
        </CPagination>  
      </CCardBody>

      <CElementCover  v-show="loading"/>
    </CCard>
  </CContainer>
</template>
<script>
  import { ref } from "vue";
  import moment from "moment";
  import { DATAGRID_DIRECTORY } from "@/helpers/moduleNames";
  import CONSTANTS from "@/constants";
  import { formatter } from "@/general";
  import { dataGridDirectorio } from "@/api";
  import { crudDirectorio } from "@/apiCRUD";

  const fields = [
    { 
      key: 'colEmpresa', 
      label: 'Empresa', 
      _style:'text-align:center;'
    },
    { 
      key: 'colUbicacion', 
      label: 'Direccion', 
      _style:'text-align:center;'
    },
    { 
      key: 'colInformacion', 
      label: 'Estado',
      _style:'text-align:center;'
    },
    {
      key: 'colAccion',
      label: ''
    }
  ]

  export default {
    name: 'ProductsEmployee',
    comments: {
      DATAGRID_DIRECTORY
    },
    data() {
      return {
        loading: false,
        fields,
        formatter,
        endpointAddContact: "",
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        directories: [],
        statusColors: {
          "A": "success",
          "M": "warning",
          "S": "danger",
          "I": "secondary",
        },
        statusHuman: {
          "A": "Activo",
          "M": "Moroso",
          "S": "Suspendido",
          "I": "Inactivo",
        },
        directoryType: {
          "CL": "Cliente",
          "PR": "Proveedor",
          "CP": "Cliente / Proveedor",
          "PP": "Prospecto",
          "TR": "Tercero",
        },
        selectedDirectoryType: 'cliente',
        directoryTypes: [
          {
            value: 'cliente',
            label: 'Clientes'
          },
          {
            value: 'proveedor',
            label: 'Proveedores'
          },
          {
            value: 'prospecto',
            label: 'Prospectos'
          },
        ],
        idDirectorySelected: ""
      }
    },
    components: {
      // JsonExcel
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true;

        try {
          this.searchWord = search
          const { count, results } = await dataGridDirectorio(
            this,
            page,
            search,
            this.selectedDirectoryType
          );

          this.directories = results;
          this.pageCount = parseInt(count / this.itemsPerPage);
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++;
          }
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      tryDelete(e, idDirectory) {
        e.preventDefault();
        e.stopPropagation();

        this.idDirectorySelected = idDirectory;
        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar"
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red"

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteDirectory();
        }).catch(() => {
          this.$alert("Se cancelo la accion!", "", "warning" , CONSTANTS.configSimpleAlert);
        });
      },
      async deleteDirectory() {
        let activeRefresh = false;
        this.loading = true;

        try {
          await crudDirectorio(this, "delete", this.idDirectorySelected);

          this.$store.commit("setAlert", {
            color: "success",
            message: "Accion exitosa",
            show: 5
          });

          activeRefresh = true;
        } catch(error) {
          console.error(error);
          
          this.$store.commit("setAlert", {
            color: "danger",
            message: CONSTANTS.messages.notDoneDelete,
            show: 5
          });
        } finally {
          this.loading = false;
        }

        if (activeRefresh) {
          this.getData(this.page);
        }
      },
      getColor(status){
        return this.statusColors[status]
      },
      getStatus(status){
        return this.statusHuman[status]
      },
      ifNullOrUndefinedReturnEmpty(value){        
        return value ? value : "";
      },
      tooltipContent(item){
        return `
          Dirección: ${this.ifNullOrUndefinedReturnEmpty(item.direccion)}
                     ${this.ifNullOrUndefinedReturnEmpty(item.direccion_Aux)}
          Ciudad: ${this.ifNullOrUndefinedReturnEmpty(item.ciudad)} - ${this.ifNullOrUndefinedReturnEmpty(item.departamento)}
          Empleado: ${this.ifNullOrUndefinedReturnEmpty(item.empleado)}
          Tipo: ${this.ifNullOrUndefinedReturnEmpty(this.directoryType[item.tipo_Directorio])}
          Actualización: ${this.ifNullOrUndefinedReturnEmpty(item.ultima_Actualizacion)}
        `
      },
      goTo(item, destiny){
        this.$store.commit("set", ["selectedDirectory", item])
        this.$router.push(
          {
            path: `${this.rootPath}/${destiny}`
          }
        );
      },
      toggleDocument(e, item){
        e.stopPropagation()
        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    async mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.endpointAddContact = `${this.rootPath}/agregar`;

      DATAGRID_DIRECTORY["route"] = this.$router.currentRoute.fullPath;

      await this.$store.dispatch("registerApplicationModule", DATAGRID_DIRECTORY);
      
      this.getData(this.page);
    }
  }
</script>